const initialState = {
  sidebarShow: window.innerWidth >= 992,   //  auto true on desktop
  sidebarUnfoldable: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SITE_SIDEBAR':
      return {
        ...state,
        sidebarShow: action.sidebarShow,
      }

    case 'SITE_TOGGLE':
      return {
        ...state,
        sidebarShow: !state.sidebarShow,
      }

    default:
      return state
  }
}

export default reducer